module.exports = __webpack_public_path__ + "jpg/first-login-avatar.jpg?b022e93d810b5d8fab9dc710f3f0a7e0";